import { useState, useEffect } from "react";
import axios from 'axios';
import { useCti } from "./useCti.ts"
import { proxyUrl } from "./Utils.jsx";

// HubSpot secure install flow - step 1 of 2: "authorize".
// HubSpot opens the install URL with step=authorize and returnUrl (the OAuth `code` is
// NOT provided yet). By the time this renders the user is already signed in to CloudCTI
// (enforced by AuthRoute in App.js), which satisfies HubSpot's "show your sign-in form"
// requirement. We then ask our backend to generate & store a single-use `state` token
// bound to the authenticated tenant, append it to returnUrl, and redirect back to HubSpot.
// HubSpot then calls us back with step=finalize + code + state (see HubSpotInstaller.jsx).
function HubspotAuthorize(brand) {
    const [status, setStatus] = useState(["Loading.."]);
    const urlParams = new URLSearchParams(window.location.search);

    // Keeps the HubSpot iframe from 'disconnecting' while we prepare the redirect.
    useCti(() => {}, () => {}, () => {});

    useEffect(() => {
        const returnUrl = urlParams.get('returnUrl');
        const securityToken = localStorage.getItem("securitytoken");
        const config = { headers: { Authorization: `Bearer ${securityToken}` } };

        if (returnUrl == null) {
            setStatus(["Initialisation error", "HubSpot did not provide a returnUrl for the authorize step."]);
            return;
        }

        // TODO (backend - hubspotservices.cloudcti.nl): implement POST /createInstallState.
        // It MUST:
        //   1. Generate a cryptographically secure random token (e.g. 32 random bytes, hex).
        //   2. Store it server-side (Redis/DB, or a signed SameSite=None; Secure cookie),
        //      keyed by the token value, with a ~10 minute expiry, associated with the
        //      authenticated CloudCTI tenant (derived from the Bearer securitytoken).
        //   3. Return it as { state: "<token>" }.
        // The token must be single-use: /oAuth (finalize) deletes it after validation.
        axios.post(proxyUrl + "/createInstallState", {}, config)
        .then(async (response) => {
            if (response.status != 200)
                throw new Error(await response.text());

            const state = response.data?.state;
            if (state == null || state === "")
                throw new Error("The authorization server did not return a state token.");

            // Use URL + searchParams.set so `state` is appended correctly even if returnUrl
            // already contains query parameters (per HubSpot guidance).
            const redirectUrl = new URL(returnUrl);
            redirectUrl.searchParams.set('state', state);
            window.location.href = redirectUrl.toString();
        }).catch((error) => {
            console.log("Error preparing HubSpot authorization");
            console.log(error);
            var strError;
            if (error.response != undefined)
                strError = error.response.data;
            else
                strError = error.toString();
            setStatus(["Encountered an error while authorizing:", strError]);
        });
    }, []);

    if (status.length == 2)
        return <div style={{ width: "100%", padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>{status[0]}</h2>
            <p style={{ textAlign: "center" }}>{status[1]}</p>
        </div>
    else
        return <div style={{ width: "100%", padding: "10px" }}>
            <h2 style={{ textAlign: "center" }}>{status[0]}</h2>
        </div>
}

export default HubspotAuthorize;
